var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Navigator extends Component {
    constructor(isDebugEnabled = false) {
        super('Navigator', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Get current page type
            let pageType = 'page';
            if ($('body').hasClass('page-template-directory_producer'))
                pageType = 'directory-producer';
            if ($('body').hasClass('page-template-directory_place'))
                pageType = 'directory-place';
            if ($('body').hasClass('page-template-agenda'))
                pageType = 'page-template-agenda';
            if ($('body').hasClass('page-template-agenda-dynamic'))
                pageType = 'agenda-dynamic';
            // Get previous page type and update interface
            const previousPageType = localStorage.getItem('previous-page-type') || 'page';
            if (previousPageType === 'directory-producer' && pageType !== 'directory-place') {
                $('.part-default').addClass('d-none');
                $('.part-directory').removeClass('d-none');
                $('.part-directory-structure').removeClass('d-none');
                $('.submenu a[href="https://corodis.ch/annuaires/compagnies/"]').addClass('btn-lavender').removeClass('btn-outline-lavender');
            }
            if (previousPageType === 'directory-place' && pageType !== 'directory-producer') {
                $('.part-default').addClass('d-none');
                $('.part-directory').removeClass('d-none');
                $('.part-directory-place').removeClass('d-none');
                $('.submenu a[href="https://corodis.ch/annuaires/theatre/"]').addClass('btn-lavender').removeClass('btn-outline-lavender');
            }
            if (previousPageType === 'agenda-dynamic' && pageType !== 'page-template-agenda') {
                $('.submenu a[href="https://corodis.ch/agenda/spectacles/"]').removeClass('btn-yellow').addClass('btn-outline-yellow');
                $('.submenu a[href="https://corodis.ch/agenda/recherche/"]').addClass('btn-yellow').removeClass('btn-outline-yellow');
            }
            // Save current page type
            if ($('body').hasClass('page-template-single-show'))
                pageType = previousPageType;
            localStorage.setItem('previous-page-type', pageType);
            this.success();
        });
    }
}
